<script setup>
const supabase = useSupabaseClient()
const user = useSupabaseUser()

const email = ref('')
const password = ref('')
const message = ref('')
const errorMsg = ref('')

const loginUser = async () => {
  try {
    const response = await $fetch('/api/auth/login', {
      method: 'POST',
      body: { email: email.value, password: password.value }
    })

    message.value = response.message
    errorMsg.value = ''

    // ✅ Store session using Supabase's built-in method
    await supabase.auth.setSession({
      access_token: response.session.access_token,
      refresh_token: response.session.refresh_token
    })

    setTimeout(() => {
      navigateTo('/users/') // Redirect to a protected page after login
    }, 2000)
  } catch (error) {
    errorMsg.value = error.statusMessage || 'Login failed.'
  }
}
</script>
<template>
  <div class="w-1/3 mx-auto mt-8 bg-[maroon] text-white p-4 rounded-md">
    <form @submit.prevent="loginUser">
      <div>
        <label
          for="email"
          class="w-fit inline-block">
          Email
        </label>
        <input
          v-model="email"
          type="email"
          placeholder="Email"
          class="bg-white text-black p-1 rounded-md w-full" />
      </div>
      <div>
        <label
          for="password"
          class="w-fit inline-block">
          Password
        </label>
        <input
          v-model="password"
          type="password"
          placeholder="Password"
          class="bg-white text-black p-1 rounded-md mt-4 w-full" />
      </div>
      <img
        src="https://media.geeksforgeeks.org/wp-content/uploads/20210917145551/eye.png"
        width="1%"
        height="1%"
        style="display: inline; margin-left: -1.5%; vertical-align: middle"
        id="togglePassword" />
      <div class="text-center mt-6">
        <button
          type="submit"
          class="rounded-md bg-blue-700 hover:bg-green-700 border-[maroon] border-1 text-white px-2 py-1">
          Sign In
        </button>
        <NuxtLink
          to="/register"
          class="text-white hover:text-[yellow] ml-4">
          Sign Up
        </NuxtLink>
      </div>
    </form>
    <p
      v-if="message"
      class="success">
      {{ message }}
    </p>
    <p
      v-if="errorMsg"
      class="error">
      {{ errorMsg }}
    </p>
  </div>
</template>

<style scoped>
.error {
  color: red;
}
.success {
  color: yellow;
}
</style>
